import { AdminStyled } from "../../Styles/admin";
import { Footer } from "../../components/Footer";
import { Header, HeaderMobil } from "../../components/Header";
import { LogoBG } from "../../components/logoBG";
import listaElevatoria from "../../Assets/Icons/listaElevatoria.svg";
import listaUsuarios from "../../Assets/Icons/listaUsuario.svg";
import { useContext } from "react";
import { HomeContext } from "../../Context/ContextHome";

export const Admin = () => {
  const { navigate, infoUser } = useContext(HomeContext);

  return (
    <AdminStyled>
      <Header pgRedireciona="/" />
      <HeaderMobil pgRedireciona="/" />

      <div className="blocoAdm">
        {infoUser.role === "4" && (
          <div
            className="blocoListas"
            onClick={() => {
              navigate("/admin/lista/elevatorias");
            }}
          >
            <img src={listaElevatoria} alt="" />
            <h3>Elevatórias</h3>
          </div>
        )}

        <div
          className="blocoListas"
          onClick={() => {
            navigate("/admin/lista/usuarios");
          }}
        >
          <img src={listaUsuarios} alt="" />
          <h3>Usuários</h3>
        </div>
      </div>
      <LogoBG />
      <Footer relative={true} background={true} />
    </AdminStyled>
  );
};
